// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"87":"0eee1a18","245":"53549b2d","361":"a6dd45db","408":"aa1bb557","453":"2f8eb9a3","823":"bbd6e8b5","872":"c82cf10a","942":"d65e2b57"}[chunkId] + ".chunk.js";
};